import {h, Fragment} from "preact"
import { useFacets, useProductFilters } from "@nosto/preact"
import { useEffect, useRef } from "preact/hooks";
import { sortSizeData } from "../helpers"

import Facet from "./elements/Facet"
import ColorFacet from "./elements/ColorFacet"
import RangeFacet from "./elements/RangeFacet"

export default function FacetsDropdown({ facetsToggleRef, facetsOpen, toggleFacets }) {
    const { facets } = useFacets();
    const { filters, removeAll } = useProductFilters();
    const dropdownRef = useRef(null);

    useEffect(() => {
        const handleClick = (event) => {
            if(
                !dropdownRef.current.contains(event.target) && 
                !facetsToggleRef.current.contains(event.target)
            ) {
                toggleFacets();
            };
        };

        if(window.innerWidth > 750 && facetsOpen && dropdownRef?.current && facetsToggleRef?.current) {
            window.document.addEventListener('click', handleClick);
            return () => window.document.removeEventListener('click', handleClick);
        };
    }, [facetsOpen, dropdownRef, facetsToggleRef]);

    return facets?.length > 0 ? (
        <div class="ns-facets-dropdown ns-custom-dropdown">
            <div className="ns-custom-dropdown__body"
                ref={dropdownRef}
                aria-expanded={facetsOpen}
            >
                <ul className="ns-m-0 ns-p-0" 
                    aria-label="Filter options"
                    role="menu" 
                    tabIndex="0" 
                >
                    {facets?.map(facet => {
                        if(facet.type === 'terms') {
                            if(facet.name === 'Size') {
                                sortSizeData(facet.data)
                            }
                            return (facet.name === 'Color') 
                                ? (<ColorFacet facet={facet} key={facet.id} />)
                                : (<Facet facet={facet} key={facet.id} />)
                        } else if (facet.type === 'stats') {
                            return (<RangeFacet facet={facet} key={facet.id} />)
                        } else {
                            return null;
                        }
                    })}
                </ul>
                <div className="ns-facets-dropdown__footer">
                    <button 
                        type="button"
                        aria-label="Apply current filters"
                        onClick={toggleFacets}
                    >
                        Apply
                    </button>

                    <button
                        type="button"
                        disabled={filters.length < 1}
                        aria-label="Remove all filters"
                        onClick={removeAll}
                    >
                        Clear All
                    </button>
                </div>
            </div>
        </div>
    ) : ( null )
}
